export interface SmaugClientConfig {
  baseUrl?: string;
  timeout?: number;
  headers?: Record<string, string>;
  authTokenProvider?: () => string | null;
}

export interface HealthResponse {
  status: string;
  timestamp?: string;
}

export interface RatingRequest {
  correlation_id: string;
  rating: 'up' | 'down';
  comments?: string;
}

export interface RatingResponse {
  rating: {
    id?: number;
    correlation_id: string;
    rating: 'up' | 'down';
    comments?: string;
    created_at?: string;
  };
}

export interface ErrorResponse {
  error?: string;
  errors?: string[];
}

export class SmaugError extends Error {
  public statusCode?: number;
  public data?: any;
  public originalError?: Error;

  constructor(message: string, statusCode?: number, data?: any, originalError?: Error) {
    super(message);
    this.name = 'SmaugError';
    if (statusCode !== undefined) {
      this.statusCode = statusCode;
    }
    if (data !== undefined) {
      this.data = data;
    }
    if (originalError !== undefined) {
      this.originalError = originalError;
    }
  }
}

export class SmaugNetworkError extends SmaugError {
  constructor(message: string, originalError?: Error) {
    super(message, undefined, undefined, originalError);
    this.name = 'SmaugNetworkError';
  }
}